import { render } from "./NotificationsDropdown.vue?vue&type=template&id=d10d9a84"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=js"

import "./NotificationsDropdown.vue?vue&type=style&index=0&id=d10d9a84&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown,QTooltip,QBadge,QBtn,QList,QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
